import { Button } from '@ps/isp-web-component-library';
import { Link, Translation } from '@ps/web-shared-components';
import { type IspSportsAlias, landingPageEventTypeIds } from '@ps/web-sports-config';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';
import { Message } from '@swf/sports/components';
import { defaultToMatchesTab } from '@swf/sports/hooks/useUrlMenuItems';

import {
  TXTWCL_OopsX_Page_not_found,
  TXTWCL_Return_To_N0
} from './EventNotFoundMessage.messages.json';
import styles from './EventNotFoundMessage.scss';

const EventNotFoundMessage: React.FC<RouteComponentProps> = ({ staticContext = {} }) => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const isEventTypeLandingPage = useSelector((state: RootState) =>
    select.sports.isEventTypeLandingPage(state, { landingPageEventTypeIds })
  );

  staticContext.statusCode = 404;

  let alias: IspSportsAlias = defaultToMatchesTab.includes(Number(eventTypeId))
    ? 'sportsMatchFiltering'
    : 'sportsSport';
  if (isEventTypeLandingPage) alias = 'sportsLanding';

  return (
    <Message message={<Translation {...TXTWCL_OopsX_Page_not_found} />}>
      <Button
        as={Link}
        alias={alias}
        values={{
          eventTypeId,
          eventTypeSlug
        }}
        className={classNames(styles.titleCase)}
      >
        <Translation values={{ 0: eventTypeSlug }} {...TXTWCL_Return_To_N0} />
      </Button>
    </Message>
  );
};

export default withRouter(EventNotFoundMessage);
